// CreateNewProduct.jsx
import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Modal, Button, Form } from "react-bootstrap";
import CompanySelectionModal from "./CompanySelectionModal";
import SelectMedicineForm from "./SelectBatchModal";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Dropdown from "react-bootstrap/Dropdown";
import { useAddNewMedicineMutation } from "../../State/Api/PharmacyStockApiSlice";

<style>{`
  /* Set all option text to black */
  select.form-select option {
    color: #000;
    background-color: #fff; /* optional white background */
  }

  /* Optional: selected value in dropdown */
  select.form-select {
    color: #000;
  }
    .custom-dropdown-item:hover {
  background-color: #4492ebff; /* Bootstrap primary blue */
  color: white;
  text-decoration: none;     /* ensure no underline */
}
`}</style>

const CreateNewProduct = ({ show, onClose, batchformik, setSelectedProduct, onCreated }) => {
  const [addNewMedicine, { isLoading: adding, isError: addError, error: addErrorObj }] =
    useAddNewMedicineMutation();

  const productFormOptions = [
    { value: "Tablet", label: "Tablet" },
    { value: "Syrup", label: "Syrup" },
    { value: "Capsule", label: "Capsule" },
    { value: "Injection", label: "Injection" },
    { value: "Cream", label: "Cream" },
    { value: "Drops", label: "Drops" },
    { value: "Powder", label: "Powder" },
    { value: "Liquid", label: "Liquid" },
    { value: "Gel", label: "Gel" },
    { value: "Paint", label: "Paint" },
    { value: "Surgicals", label: "Surgicals" },
    { value: "Suspension", label: "Suspension" },
    { value: "Oil", label: "Oil" },
    { value: "Lotion", label: "Lotion" },
    { value: "Bandage", label: "Bandage" },
    { value: "Ointment", label: "Ointment" },
    { value: "Soap", label: "Soap" },
    { value: "Diaper", label: "Diaper" },
    { value: "Device", label: "Device" },
    { value: "Kit", label: "Kit" },
    { value: "Spray", label: "Spray" },
    { value: "Sachet", label: "Sachet" },
    { value: "Shampoo", label: "Shampoo" },
    { value: "Facewash", label: "Facewash" },
    { value: "Bottle", label: "Bottle" },
    { value: "Solution", label: "Solution" },
    { value: "Infusion", label: "Infusion" },
    { value: "Condom", label: "Condom" },
    { value: "Sanitary Pad", label: "Sanitary Pad" },
    { value: "Box", label: "Box" },
    { value: "Packet", label: "Packet" },
    { value: "Elixir", label: "Elixir" },
    { value: "Paste", label: "Paste" },
    { value: "Bolus", label: "Bolus" },
    { value: "Inhaler", label: "Inhaler" },
    { value: "Balm", label: "Balm" },
    { value: "Respule", label: "Respule" },
    { value: "Toothpaste", label: "Toothpaste" },
    { value: "Unit", label: "Unit" },
    { value: "Syringe", label: "Syringe" },
    { value: "Toothbrush", label: "Toothbrush" },
    { value: "Churna", label: "Churna" },
    { value: "Serum", label: "Serum" },
    { value: "Granules", label: "Granules" },
    { value: "Jelly", label: "Jelly" },
    { value: "Strip", label: "Strip" },
    { value: "Plaster", label: "Plaster" },
    { value: "Face Mask", label: "Face Mask" },
    { value: "Deodorant", label: "Deodorant" },
    { value: "Roll On", label: "Roll On" },
    { value: "Mouthwash", label: "Mouthwash" },
    { value: "Gummies", label: "Gummies" },
    { value: "Chyawanprash", label: "Chyawanprash" },
    { value: "Wipe", label: "Wipe" },
    { value: "Expectorant", label: "Expectorant" },
    { value: "Pouch", label: "Pouch" },
    { value: "Wash", label: "Wash" },
    { value: "Suppository", label: "Suppository" },
    { value: "Rotacap", label: "Rotacap" },
    { value: "Patch", label: "Patch" },
    { value: "Card", label: "Card" },
    { value: "Tube", label: "Tube" },
    { value: "Vaccine", label: "Vaccine" },
    { value: "Thermometer", label: "Thermometer" },
    { value: "Honey", label: "Honey" },
    { value: "Razor", label: "Razor" },
    { value: "Jar", label: "Jar" },
    { value: "Lozenges", label: "Lozenges" },
    { value: "Water", label: "Water" },
    { value: "Conditioner", label: "Conditioner" },
    { value: "Bar", label: "Bar" },
    { value: "Particles", label: "Particles" },
    { value: "Liniment", label: "Liniment" },
    { value: "Tincture", label: "Tincture" },
    { value: "Handwash", label: "Handwash" },
    { value: "Gum", label: "Gum" },
    { value: "Foam", label: "Foam" },
    { value: "Gargle", label: "Gargle" },
    { value: "Nebulisers", label: "Nebulisers" },
    { value: "Vial", label: "Vial" },
    { value: "Ampules", label: "Ampules" },
    { value: "Lozenge", label: "Lozenge" },
    { value: "Scrub", label: "Scrub" },
    { value: "Diskette", label: "Diskette" },
    { value: "Cleanser", label: "Cleanser" },
    { value: "Adhesive", label: "Adhesive" },
    { value: "Moisturiser", label: "Moisturiser" },
    { value: "Soflets", label: "Soflets" },
    { value: "Pastilles", label: "Pastilles" },
    { value: "Linctus", label: "Linctus" },
    { value: "Transcap", label: "Transcap" },
    { value: "Grains", label: "Grains" },
    { value: "Emulsion", label: "Emulsion" },
    { value: "Respicap", label: "Respicap" },
    { value: "Instacap", label: "Instacap" },
    { value: "Husk", label: "Husk" },
    { value: "Enema", label: "Enema" },
    { value: "Pessary", label: "Pessary" },
    { value: "Pellet", label: "Pellet" },
    { value: "Cartrige", label: "Cartrige" },
    { value: "Pen", label: "Pen" },
    { value: "Rotahaler", label: "Rotahaler" },
    { value: "Tonic", label: "Tonic" },
    { value: "Lacquer", label: "Lacquer" },
    { value: "Aerosol", label: "Aerosol" },
    { value: "Redicap", label: "Redicap" },
    { value: "Novocart", label: "Novocart" },
    { value: "Film", label: "Film" },
    { value: "Captabs", label: "Captabs" },
    { value: "Gummy", label: "Gummy" },
    { value: "Solvent", label: "Solvent" },
    { value: "Particle", label: "Particle" },
    { value: "Vegicaps", label: "Vegicaps" },
    { value: "Opticops", label: "Opticops" },
    { value: "Caplets", label: "Caplets" },
    { value: "Rapitab", label: "Rapitab" },
    { value: "Autopen", label: "Autopen" },
    { value: "Tabcaps", label: "Tabcaps" },
    { value: "Intrauterine System", label: "Intrauterine System" },
    { value: "Pessaries", label: "Pessaries" },
    { value: "Multihaler", label: "Multihaler" },
    { value: "Transpule", label: "Transpule" },
    { value: "Transhaler", label: "Transhaler" },
    { value: "Alicaps", label: "Alicaps" },
    { value: "Autohaler", label: "Autohaler" },
    { value: "Aquanase", label: "Aquanase" },
    { value: "Oxycaps", label: "Oxycaps" },
    { value: "Oxipule", label: "Oxipule" },
    // ... (list continues)
  ];

  const [showCompanyModal, setShowCompanyModal] = React.useState(false);
  const [showProductModal, setShowProductModal] = React.useState(false);

  const handleCreateNewCompany = (newCompanyName) => {
    console.log("Creating new company:", newCompanyName);
    formik.setFieldValue("companyName", newCompanyName);
    setShowCompanyModal(false); // close the company modal
  };

  const formik = useFormik({
    initialValues: {
      productName: "",
      companyName: "",
      productForm: "",
      mrp: "",
      unitsPerPack: "",
      composition: "",
    },
    validationSchema: Yup.object({
      productName: Yup.string().required("*Required"),
      companyName: Yup.string().required("*Required"),
      productForm: Yup.string().required("*Required"),
      mrp: Yup.string().required("*Required"),
      unitsPerPack: Yup.string().required("*Required"),
    }),
onSubmit: async (values, { setSubmitting, resetForm }) => {
  try {
    setSubmitting(true);
    const pharmaId = localStorage.getItem("userUniqueID") || "";
    const payload = {
      pharmaId,
      productname: values.productName,
      cmpnyName: values.companyName,
      prdctFrom: values.productForm,
      mrp: values.mrp,
      unitsPerPack: values.unitsPerPack,
    };
    const result = await addNewMedicine(payload).unwrap();

  
    const createdProduct = {
      productName: payload.productname,
      productID: result.productID,
      cmpnyName: payload.cmpnyName,
      mrp: payload.mrp,
      unitsPerPack: payload.unitsPerPack,
    };


    if (typeof onCreated === "function") {
      onCreated(createdProduct);
    }

    resetForm();
    onClose();
  } catch (err) {
    console.error("Add new medicine failed:", err);
  } finally {
    setSubmitting(false);
  }
},

  });

  // Dynamic input style helper
  const getInputStyle = (field, isError) => ({
    fontSize: formik.values[field] ? "14px" : "13px",
    color: formik.values[field] ? "#000" : "#555",
    padding: "8px 10px",
    borderRadius: "4px",
    borderColor: isError ? "red" : "#ced4da",
    cursor: "pointer",
    backgroundColor: "#fff",
  });

  return (
    <>
      {!showCompanyModal && !showProductModal && (
        <Modal show={show} onHide={onClose} centered backdrop="static">
          <Modal.Header
            closeButton
            style={{ paddingBottom: "6px", borderBottom: "none" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Modal.Title
                style={{ fontWeight: "600", fontSize: "19px", color: "#555" }}
              >
                Create New Product
              </Modal.Title>

              <Button
                type="submit"
                className="gradient-button"
                form="create-product-form"
                style={{
                  border: "none",
                  padding: "6px 16px",
                  fontSize: "14px",
                  fontWeight: "600",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                disabled={formik.isSubmitting || adding}
              >
                {formik.isSubmitting || adding ? "Creating..." : "Create"}
              </Button>
            </div>
          </Modal.Header>

          <Modal.Body style={{ paddingTop: "0", paddingBottom: "8px" }}>
            <Form id="create-product-form" onSubmit={formik.handleSubmit}>
              {/* PRODUCT NAME */}
              <Form.Group className="mb-2">
                <Form.Label
                  style={{ fontSize: "14px", fontWeight: "600", color: "#555" }}
                >
                  Product Name<span style={{ color: "red" }}> *</span>
                </Form.Label>
                <Form.Control
                  name="productName"
                  value={formik.values.productName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.touched.productName && formik.errors.productName}
                  style={{
                    ...getInputStyle(
                      "productName",
                      formik.touched.productName && formik.errors.productName
                    ),
                    color: "#000", // black text
                    borderColor: "#000", // black border
                  }}
                  placeholder="Enter product name"
                  className="black-placeholder"
                />
                <Form.Control.Feedback type="invalid" style={{ fontSize: "12px" }}>
                  {formik.errors.productName}
                </Form.Control.Feedback>
              </Form.Group>

              {/* COMPANY NAME */}
              <Form.Group className="mb-2">
                <Form.Label
                  style={{ fontSize: "14px", fontWeight: "600", color: "#555" }}
                >
                  Company Name<span style={{ color: "red" }}> *</span>
                </Form.Label>
                <Form.Control
                  name="companyName"
                  value={formik.values.companyName}
                  placeholder="Select a company"
                  onClick={() => setShowCompanyModal(true)}
                  isInvalid={formik.touched.companyName && formik.errors.companyName}
                  style={getInputStyle(
                    "companyName",
                    formik.touched.companyName && formik.errors.companyName
                  )}
                />
                <Form.Control.Feedback type="invalid" style={{ fontSize: "12px" }}>
                  {formik.errors.companyName}
                </Form.Control.Feedback>
              </Form.Group>

              {/* PRODUCT FORM */}
              <Form.Group className="mb-2">
                <Form.Label style={{ fontSize: "14px", fontWeight: "600", color: "#555" }}>
                  Product Form<span style={{ color: "red" }}> *</span>
                </Form.Label>

                <Dropdown>
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    style={{
                      fontSize: "12px",
                      minHeight: "36px",
                      width: "100%",
                      textAlign: "left",
                      borderColor:
                        formik.touched.productForm && formik.errors.productForm
                          ? "red"
                          : "#000",
                      color: formik.values.productForm ? "#000" : "#555",
                      backgroundColor: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      {
                        productFormOptions.find(
                          (opt) => opt.value === formik.values.productForm
                        )?.label || "Select a Product Form"
                      }
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    style={{
                      maxHeight: "200px",
                      overflowY: "auto",
                      fontSize: "12px",
                      width: "100%",
                    }}
                  >
                    {productFormOptions.map((option) => (
                      <Dropdown.Item
                        key={option.value}
                        onClick={() => formik.setFieldValue("productForm", option.value)}
                        active={formik.values.productForm === option.value}
                        style={{
                          textDecoration: "none",
                        }}
                        className="custom-dropdown-item"
                      >
                        {option.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                {formik.touched.productForm && formik.errors.productForm && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {formik.errors.productForm}
                  </div>
                )}
              </Form.Group>

              {/* MRP + UNITS PER PACK */}
              <div className="row" style={{ margin: "0 -4px" }}>
                <div className="col-6" style={{ padding: "0 4px" }}>
                  <Form.Group className="mb-2">
                    <Form.Label
                      style={{ fontSize: "14px", fontWeight: "600", color: "#555" }}
                    >
                      Mrp<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      name="mrp"
                      placeholder="Enter Product MRP here"
                      value={formik.values.mrp}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={formik.touched.mrp && formik.errors.mrp}
                      style={{
                        ...getInputStyle("mrp", formik.touched.mrp && formik.errors.mrp),
                        borderColor: "#000", // black border
                        color: "#000", // black text
                      }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: "12px" }}>
                      {formik.errors.mrp}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>

                <div className="col-6" style={{ padding: "0 4px" }}>
                  <Form.Group className="mb-2">
                    <Form.Label
                      style={{ fontSize: "14px", fontWeight: "600", color: "#555" }}
                    >
                      Units Per Pack<span style={{ color: "red" }}> *</span>
                    </Form.Label>
                    <Form.Control
                      name="unitsPerPack"
                      placeholder="No of Tablets in a Strip"
                      value={formik.values.unitsPerPack}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        formik.touched.unitsPerPack && formik.errors.unitsPerPack
                      }
                      style={{
                        ...getInputStyle(
                          "unitsPerPack",
                          formik.touched.unitsPerPack && formik.errors.unitsPerPack
                        ),
                        borderColor: "#000", // black border
                        color: "#000", // black text
                      }}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: "12px" }}>
                      {formik.errors.unitsPerPack}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>
              </div>

              {/* COMPOSITION (optional) */}
            </Form>
            {addError && (
              <div style={{ color: "red", marginTop: 8 }}>
                Failed to create product. {addErrorObj?.data?.message || ""}
              </div>
            )}
          </Modal.Body>
        </Modal>
      )}

      <CompanySelectionModal
        show={showCompanyModal}
        onClose={() => setShowCompanyModal(false)}
        onSelect={(selectedCompany) =>
          formik.setFieldValue("companyName", selectedCompany)
        }
        onCreateNew={handleCreateNewCompany}
      />
    </>
  );
};

export default CreateNewProduct;
